export function twoDigit(num: number): string {
    return num.toLocaleString('en-US', {
        minimumIntegerDigits: 2,
        useGrouping: false,
    });
}

export const average = (arr: number[]): number =>
    arr.reduce((p, c) => p + c, 0) / arr.length;

export const calculatePercentiles = (
    precentiles: number[],
    arr: number[],
    includeAvg = true
): Record<string, number> => {
    const sorted = arr.sort((a, b) => a - b);
    const result: Record<string, number> = {};
    precentiles.forEach((p) => {
        const index = Math.min(
            sorted.length - 1,
            Math.floor((p / 100) * sorted.length)
        );
        result[`p${p}`] = sorted[index];
    });
    if (includeAvg) {
        result.avg = average(arr);
    }
    result.numberOfSamples = arr.length;
    return result;
};
